export default function FeaturedResources() {
  const resources = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Sugargoo Spreadsheet',
      description: 'Complete product finding resources with organized categories, QC references and seller ratings all in one place.',
      link: 'https://kaspreadsheet.com',
      img: 'https://readdy.ai/api/search-image?query=Organized%20spreadsheet%20interface%20displayed%20on%20a%20clean%20modern%20laptop%20screen%20with%20colorful%20product%20category%20tabs%20and%20data%20rows%2C%20warm%20cream%20background%2C%20soft%20natural%20window%20lighting%2C%20a%20notepad%20and%20pen%20beside%20the%20laptop%2C%20professional%20data%20management%20concept%2C%20clean%20editorial%20photography%20with%20gentle%20shadows%20and%20productive%20workspace%20atmosphere&width=800&height=500&seq=featured-res-01&orientation=landscape',
    },
    {
      icon: 'ri-star-line',
      title: 'Sugargoo Review',
      description: 'Independent platform analysis covering features, pricing, user experience and honest pros and cons from real shoppers.',
      link: 'https://kaspreadsheet.com',
      img: 'https://readdy.ai/api/search-image?query=Five%20star%20rating%20graphic%20and%20review%20checklist%20on%20a%20clean%20cream%20desk%20surface%20with%20a%20smartphone%20showing%20review%20interface%2C%20warm%20soft%20natural%20lighting%2C%20consumer%20review%20and%20rating%20concept%2C%20modern%20editorial%20product%20photography%20with%20gentle%20shadows%20and%20organized%20composition%20with%20a%20coffee%20cup%20nearby&width=800&height=500&seq=featured-res-02&orientation=landscape',
    },
    {
      icon: 'ri-ship-line',
      title: 'Sugargoo Shipping Cost',
      description: 'Shipping calculator guides comparing all available methods, delivery times and cost breakdowns by weight and destination country.',
      link: 'https://kaspreadsheet.com',
      img: 'https://readdy.ai/api/search-image?query=International%20shipping%20concept%20with%20a%20small%20globe%20and%20miniature%20cardboard%20boxes%20on%20a%20cream%20surface%2C%20soft%20warm%20natural%20lighting%2C%20a%20shipping%20rate%20comparison%20chart%20printed%20on%20paper%20beside%20the%20globe%2C%20global%20logistics%20concept%2C%20clean%20editorial%20product%20photography%20with%20gentle%20shadows%20and%20organized%20professional%20aesthetic&width=800&height=500&seq=featured-res-03&orientation=landscape',
    },
    {
      icon: 'ri-building-line',
      title: 'Sugargoo Warehouse',
      description: 'Complete explanation of warehouse operations, storage policies, QC process and consolidation strategies for maximum efficiency.',
      link: 'https://kaspreadsheet.com',
      img: 'https://readdy.ai/api/search-image?query=Clean%20organized%20warehouse%20interior%20with%20labeled%20storage%20shelves%20and%20product%20packages%2C%20warm%20soft%20industrial%20lighting%2C%20an%20inspection%20checklist%20clipboard%20on%20a%20wooden%20table%20in%20the%20foreground%2C%20cream%20and%20beige%20tones%20throughout%2C%20professional%20fulfillment%20center%20atmosphere%2C%20editorial%20photography%20with%20natural%20light%20and%20gentle%20shadows&width=800&height=500&seq=featured-res-04&orientation=landscape',
    },
    {
      icon: 'ri-coupon-line',
      title: 'Sugargoo Coupon',
      description: 'Latest discount information, promotional codes and seasonal savings opportunities updated regularly for smart shoppers.',
      link: 'https://kaspreadsheet.com',
      img: 'https://readdy.ai/api/search-image?query=Colorful%20discount%20coupon%20cards%20and%20percentage%20off%20tags%20arranged%20beautifully%20on%20a%20cream%20surface%2C%20warm%20soft%20natural%20lighting%2C%20a%20smartphone%20showing%20a%20shopping%20cart%20with%20discount%20applied%20beside%20the%20cards%2C%20money%20saving%20retail%20concept%2C%20clean%20editorial%20product%20photography%20with%20gentle%20shadows%20and%20inviting%20promotional%20aesthetic&width=800&height=500&seq=featured-res-05&orientation=landscape',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Is Sugargoo Legit',
      description: 'Safety and trust analysis covering payment security, buyer protection, and real user experiences from the Sugargoo community.',
      link: 'https://kaspreadsheet.com',
      img: 'https://readdy.ai/api/search-image?query=A%20shield%20icon%20and%20checkmark%20certificate%20on%20a%20clean%20cream%20desk%20with%20a%20smartphone%20showing%20secure%20payment%20interface%2C%20warm%20soft%20natural%20lighting%2C%20safety%20and%20trust%20verification%20concept%2C%20modern%20editorial%20product%20photography%20with%20gentle%20shadows%20and%20reassuring%20professional%20composition%20with%20a%20magnifying%20glass%20beside%20the%20items&width=800&height=500&seq=featured-res-06&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold mb-4 whitespace-nowrap">
            Resource Hub
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Featured Sugargoo Resources
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto text-sm leading-relaxed">
            Explore our complete collection of independent guides and tools designed to enhance your Sugargoo shopping experience.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {resources.map((res, idx) => (
            <a
              key={idx}
              href={res.link}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="w-full h-44 overflow-hidden">
                <img
                  src={res.img}
                  alt={res.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${res.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors">
                  {res.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">{res.description}</p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                  Learn More <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}